import { WpModes } from '../constants';

// Synchronous, session-lifetime mirror of the last-known WpPostInfo per post/task.
// Lets setActivePostId2 prefill fields (e.g. tags) instantly, the same way it already
// prefills title/abbr/flag/snooze from the sidebar list row, without waiting on the
// async IndexedDB round-trip that DbUtils.wp_load_post_info/wp_load_task_info require.
const mem = new Map<string, any>();

const keyOf = (wpMode: WpModes | null | undefined, postId: string) =>
  (wpMode == WpModes.Task ? `tkpi_${postId}` : `wlpi_${postId}`);

export const WpPostInfoMem = {
  set(wpMode: WpModes | null | undefined, postId: string | null | undefined, postInfo: any): void {
    if (!postId || !postInfo) return;
    mem.set(keyOf(wpMode, postId), postInfo);
  },

  get(wpMode: WpModes | null | undefined, postId: string | null | undefined): any {
    if (!postId) return null;
    return mem.get(keyOf(wpMode, postId)) ?? null;
  },
};
